import baseAPI from "@/api/base";
import { GetPayments } from "@/dtos/payment.dto";
import { PAYMENT_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

class Payment {
    // GET /payment — every payment across all organizations (admin-only),
    // optionally filtered by a created-at date range.
    static getPayments = async (params?: GetPayments): Promise<AxiosResponse> => {
        return baseAPI.get(PAYMENT_URL, { params: params ?? {} });
    };
}

export default Payment;
